import { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { Alert, InlineAlert } from "evergreen-ui";
import { useFormik } from "formik";
import Yup from "validation/Validation";

const YoutubeVideoEkle = (props) => {
  const { onClose, open, youtube, setYoutube, ...other } = props;
  const [initialValues, setInitialValues] = useState({
    youtubeUrl: youtube.youtubeLink,
    videoWidth: youtube.width,
    videoHight: youtube.height,
  });

  const handleCancel = () => {
    onClose();
  };

  const extractVideoIdFromUrl = (url) => {
    const match = url.match(
      /(?:\?v=|\/embed\/|\/watch\?v=|\/\d{11}\/|\d{11}\/|^v=)([a-zA-Z0-9_-]{11})(?=&|$|\?|#)/
    );
    if (match) {
      return match[1];
    }
    return null;
  };

  const formFields = {
    youtubeUrl: Yup.string(),
    videoWidth: Yup.string(),
    videoHight: Yup.string(),
  };

  const validationSchema = Yup.object(formFields);
  const formikConfig = {
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnChange: false,
    enableReinitialize: true,
    validate: (values) => {
      if (values.youtubeUrl) {
        const errors = {};
        const videoId = extractVideoIdFromUrl(values.youtubeUrl);
        if (!videoId) {
          errors.youtubeUrl = true;
        }
        return errors;
      }
    },
    onSubmit: async(values, { setSubmitting }) => {
      if (values.youtubeUrl) {
        const videoId = extractVideoIdFromUrl(values.youtubeUrl);
        setYoutube({
          youtubeUrl: videoId,
          width: values.videoWidth,
          height: values.videoHight,
        });
        setInitialValues({
          youtubeUrl:values.youtubeLink,
          videoWidth:values.width,
          videoHight:values.height,
        });
      } else {
        setYoutube(false);
      }
      onClose(true);
    },
  };

  const { handleSubmit, handleChange, values, errors } =
    useFormik(formikConfig);

  useEffect(() => {
    if (youtube) {
      const initObject = {
        youtubeUrl: youtube.youtubeLink,
        videoWidth: youtube.width,
        videoHight: youtube.height,
      };
      setInitialValues(initObject);
    }
  }, [youtube]);

  return (
    <Mui.Dialog
      sx={{ "& .MuiDialog-paper": { width: "100%" } }}
      maxWidth="md"
      open={open}
      {...other}
    >
      <Mui.DialogTitle>YouTube Video</Mui.DialogTitle>
      <Mui.Box
        component="form"
        noValidate
        onSubmit={handleSubmit}
        sx={{ mt: 1 }}
      >
        <Mui.DialogContent dividers>
          <Mui.FormControl fullWidth>
            <div className="w-full flex items-center gap-4">
              <div className="w-full flex flex-col gap-2">
                <div className="w-full">
                  <Alert
                    intent="warning"
                    title="Videoyu kaldırmak için video linkini silebilirsiniz"
                    marginBottom={10}
                  />
                  {errors.youtubeUrl && (
                    <InlineAlert intent="danger" marginBottom={10}>
                      Girdiğiniz link bir YouTube videosuna ait değil
                    </InlineAlert>
                  )}
                  <Mui.TextField
                    sx={{ m: 0 }}
                    size="small"
                    margin="normal"
                    fullWidth
                    id="youtubeUrl"
                    label="YouTube Video Linki"
                    name="youtubeUrl"
                    autoComplete="youtubeUrl"
                    onChange={handleChange}
                    key={initialValues.youtubeUrl}
                    defaultValue={initialValues.youtubeUrl}
                    values={values.youtubeUrl}
                    error={errors.youtubeUrl ? true : false}
                  />
                </div>
                <div className="w-full flex items-center gap-2">
                  <Mui.TextField
                    sx={{ m: 0 }}
                    size="small"
                    margin="normal"
                    fullWidth
                    id="videoWidth"
                    label="Video Genişlik Boyutu örn: 400"
                    name="videoWidth"
                    autoComplete="videoWidth"
                    onChange={handleChange}
                    key={initialValues.videoWidth}
                    defaultValue={initialValues.videoWidth}
                    values={values.videoWidth}
                    helperText={errors.videoWidth && errors.videoWidth}
                    error={errors.videoWidth ? true : false}
                  />
                  <Mui.TextField
                    sx={{ m: 0 }}
                    size="small"
                    margin="normal"
                    fullWidth
                    id="videoHight"
                    label="Video Yükseklik Boyutu örn: 310"
                    name="videoHight"
                    autoComplete="videoHight"
                    onChange={handleChange}
                    key={initialValues.videoHight}
                    defaultValue={initialValues.videoHight}
                    values={values.videoHight}
                    helperText={errors.videoHight && errors.videoHight}
                    error={errors.videoHight ? true : false}
                  />
                </div>
              </div>
            </div>
          </Mui.FormControl>
        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Button
            sx={{ mr: 1 }}
            startIcon={<MuiIcons.Cancel />}
            variant="contained"
            size="small"
            color="error"
            autoFocus
            onClick={handleCancel}
          >
            Kapat
          </Mui.Button>
          <Mui.Button
            endIcon={<MuiIcons.CheckCircle />}
            variant="contained"
            size="small"
            color="success"
            type="submit"
          >
            Kaydet
          </Mui.Button>
        </Mui.DialogActions>
      </Mui.Box>
    </Mui.Dialog>
  );
};

export default YoutubeVideoEkle;
